
import { CoverPageTemplate } from "../../types/cover.types";
import floralBrownBg from "../assets/floral-brown-bg.jpeg";
import floralTemplateBg from "../assets/floral-template-bg.jpeg";
import janieBg from "../assets/janie-bg.jpeg";
import floralBrownFg from "../assets/floral-brown-fg.png";
import floralTemplateFg from "../assets/floral-template-fg.png";
import janieFg from "../assets/janie-fg.jpeg";
import conferenceBg from "../assets/conference-layout-bg.jpeg";
import conferenceFg from "../assets/conference-layout-fg.jpeg";
import modernBlendBg from "../assets/modern-blend-bg.jpeg"
import modernBlendFg from "../assets/modern-blend-fg.jpeg"
import vintageCoverBg from "../assets/vintage-cover-bg.jpeg"
import vintageCoverFg from "../assets/vintage-cover-fg.jpeg"
import jamieBg from "../assets/jamie-bg.png"
import jamieFg from "../assets/jamie-fg.png"

export const COVER_TEMPLATES: CoverPageTemplate[] = [
  {
    id: 1,
    name: "Floral Template",
    description: "Classic floral design",
    category: "funeral",
    theme_color: "#000000",
    background_image: floralTemplateBg,
    foreground_image: floralTemplateFg,
    layout: 1,
    is_active: true,
    created_at: "",
    updated_at: "",
    created_by: 0,
    last_updated_by: 0,
    company: {
      id: 1,
      name: "Muzukuru",
    },
  },
  {
    id: 2,
    name: "Floral Brown",
    description: "Brown floral with photo support",
    category: "funeral",
    theme_color: "#000000",
    background_image: floralBrownBg,
    foreground_image: floralBrownFg,
    layout: 1,
    is_active: true,
    created_at: "",
    updated_at: "",
    created_by: 0,
    last_updated_by: 0,
    company: {
      id: 1,
      name: "Muzukuru",
    },
  },
  {
    id: 6,
    name: "Code 4 - Janie",
    description: "Elegant arched photo design",
    category: "funeral",
    theme_color: "#000000",
    background_image: janieBg,
    foreground_image: janieFg,
    layout: 3,
    is_active: true,
    created_at: "",
    updated_at: "",
    created_by: 0,
    last_updated_by: 0,
    company: {
      id: 1,
      name: "Muzukuru",
    },
  },
  {
    id: 7,
    name: "Conference Template",
    description: "Sleek design for conference proposals",
    category: "conference",
    theme_color: "#000000",
    background_image: conferenceBg,
    foreground_image: conferenceFg,
    layout: 6,
    is_active: true,
    created_at: "",
    updated_at: "",
    created_by: 0,
    last_updated_by: 0,
    company: {
      id: 1,
      name: "Muzukuru",
    },
  },
  {
    id: 8,
    name: "Modern Blend",
    description: "Modern design with blend background",
    category: "funeral",
    theme_color: "#000000",
    background_image: modernBlendBg,
    foreground_image: modernBlendFg,
    layout: 5,
    is_active: true,
    created_at: "",
    updated_at: "",
    created_by: 0,
    last_updated_by: 0,
    company: {
      id: 1,
      name: "Muzukuru",
    },
  },
  {
    id: 10,
    name: "Vintage Cover",
    description: "Classic vintage design",
    category: "funeral",
    theme_color: "#000000",
    background_image: vintageCoverBg,
    foreground_image: vintageCoverFg,
    layout: 4,
    is_active: true,
    created_at: "",
    updated_at: "",
    created_by: 0,
    last_updated_by: 0,
    company: {
      id: 1,
      name: "Muzukuru",
    },

  },
  {
    id: 11,
    name: "Jamie Template",
    description: "Clean design with photo support",
    category: "funeral",
    theme_color: "#000000",
    background_image: jamieBg,
    foreground_image: jamieFg,
    layout: 2,
    is_active: true,
    created_at: "",
    updated_at: "",
    created_by: 0,  
    last_updated_by: 0,
    company: {
      id: 1,
      name: "Muzukuru",
    },
  },
];
